type Tprops = { args: any; pass: { arrStrings: string[] } };

export const whereConds = (props: Tprops) => {
  // console.log('Dentro Where Conds');
  // ---------- set Props
  const { arrStrings } = props.pass;
  console.log({ arrStrings });

  const objReturn = {
    field: arrStrings[0] ?? 'undefined',
    operator: arrStrings[1] ?? '==',
    value: arrStrings[2] ?? 'undefined',
  };

  console.log('whereCond', { objReturn });
  return objReturn;
};
